import React from 'react'
import { Info } from 'lucide-react'
import { money } from '../financial/formatting'
import { count, fmtClock } from './model'

// Sales per buyer: a bar for leads sold, scaled to the best buyer, with
// revenue beside it and the contact counts underneath. The API has no
// our/partner split per buyer, so there is none here.
export default function BuyerSalesCard({ rows, notice, asOf, stale, timezone, palette }) {
  const sorted = [...(rows || [])].sort((a, b) => b.sold - a.sold || b.revenue - a.revenue || b.contacted - a.contacted)
  const maxSold = Math.max(1, ...sorted.map((r) => r.sold))

  return (
    <section className="card" aria-labelledby="sl-buyers-title" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
        <h2 id="sl-buyers-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Sales by buyer</h2>
        {!notice && stale && asOf && (
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Buyer data as of {fmtClock(asOf, timezone)} ET</span>
        )}
      </div>

      {notice ? (
        <p style={{ margin: 0, display: 'flex', gap: 8, fontSize: 13, color: 'var(--text-secondary)' }}>
          <Info size={15} aria-hidden="true" style={{ flexShrink: 0, marginTop: 2 }} />
          {notice}
        </p>
      ) : sorted.length === 0 ? (
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>No buyer was contacted in this range.</p>
      ) : (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 14 }}>
          {sorted.map((r) => (
            <li key={r.buyer_id}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 13 }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, fontWeight: 600, color: 'var(--text-primary)' }}>
                  <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: 999, flexShrink: 0, background: palette.forId(r.buyer_id) }} />
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.buyer}</span>
                </span>
                <span style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', color: 'var(--text-secondary)' }}>
                  <strong style={{ color: 'var(--text-primary)' }}>{count(r.sold)}</strong> sold · {money(r.revenue)}
                </span>
              </div>
              <div aria-hidden="true" style={{ marginTop: 6, height: 8, borderRadius: 4, background: 'var(--bg-raised)' }}>
                <div style={{ width: `${(r.sold / maxSold) * 100}%`, minWidth: r.sold > 0 ? 4 : 0, height: '100%', borderRadius: 4, background: palette.forId(r.buyer_id) }} />
              </div>
              <div style={{ marginTop: 4, fontSize: 11, color: 'var(--text-muted)' }}>
                {count(r.contacted)} contacted · {count(r.bids)} bids · {count(r.declined)} declined · {count(r.timeout)} timeout
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
